import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData } from '../../helpers/fackBackend_Helper';

function* getBulkActivationReportResponse({ payload: { searchData } }) {
    try {
        const response = yield call(addData, '/getBulkActivationReport', searchData);
        if (response.Status) {
            yield put(
                actions.getBulkActivationReportSuccess(
                    response.Data
                ));
        } else {

            yield put(actions.getBulkActivationReportFailed(response.Message));
        }
    } catch (error) {

        yield put(actions.getBulkActivationReportFailed(error));
    }
}

export default function* rootSaga() {
    yield all([takeEvery(actions.GET_BULK_ACTIVATION_REPORT, getBulkActivationReportResponse)]);

}
